import { useEffect, useState } from "react";
import Gradient from "javascript-color-gradient";
import { nodeParameters, parametersNames, parameterPrecision } from "../config/config";
import { useStyle } from "../style/style-context";
import { MultiGraph } from "graphology";

const nodeThemeGradients = {
  'color': new Gradient().setColorGradient("#00FF00", "#0000FF", "#FF0000").setMidpoint(20).getColors(),
  'color-2':new Gradient().setColorGradient("#3F2CAF", "#e9446a").setMidpoint(20).getColors(),
  'black-white': new Gradient().setColorGradient("#F3F3F3", "#000000").setMidpoint(20).getColors(),
  'black-white-2': new Gradient().setColorGradient("#A1A1A1", "#000000").setMidpoint(20).getColors()
}

export function createCircle(lat, lon, caption, value, maxValue, style) {
  const maxSize = style.node_max_size;
  const minSize = style.node_min_size;
  const maxGrad = 19.0;
  const gradientArray = nodeThemeGradients[style.node_theme]

  const color = gradientArray[Math.ceil((maxGrad / maxValue) * value)];
  return new window.ymaps.Circle(
    [[lat, lon], minSize + (maxSize / maxValue) * value],
    {
      balloonContentBody: caption
    },
    {
      draggable: false,
      fillColor: color,
      strokeColor: "#000000",
      strokeWidth: 0,
    }
  );
}

export function buildDistribution(graph, style, parameter) {
  const collection = new window.ymaps.GeoObjectCollection();
  if(!graph) {
    return collection
  }
  var maxValue = 0.0;
  graph.forEachNode((node, attrs) => {
    const value = parseFloat(attrs[parameter]);
    if (value > maxValue) {
      maxValue = value;
    }
  });
  console.log(parameter + ".max = ", maxValue);

  graph.forEachNode((node, attrs) => {
    const value = attrs[parameter];
    if (value > 0) {
      var caption = ""
      for(var key in attrs) {
        if(nodeParameters.includes(key)) {
          const precision = parameterPrecision[key]
          caption += "<b>" + parametersNames[key] + " = </b>" + (precision ? attrs[key].toFixed(precision) : attrs[key]);
          caption += "<br/>"
        }
      }
      var crossing = new Set([])
      graph.forEachNeighbor(node, function(neighbor, attributes) {        
          crossing.add(graph.getEdgeAttribute(node, neighbor, 'name'))
      });

      caption = [...crossing].join(' x ') + "<br/></br>" + caption

      collection.add(createCircle(attrs.y ?? attrs.lat, attrs.x ?? attrs.lon, caption, value, maxValue, style));
    }
  });

  return collection;
}

export const DistributionLayout = ({ map, graph, parameter, enabled }) => {
  const [distribution, setDistribution] = useState(null);
  const {style} = useStyle()

  useEffect(() => {
    map.geoObjects.remove(distribution);
    setDistribution(buildDistribution(graph, style, parameter));
  }, [style, graph]);

  useEffect(() => {
    if (distribution && enabled) {
      map.geoObjects.add(distribution);
    } else {
      map.geoObjects.remove(distribution);
    }
  }, [distribution, enabled]);
  return null;
};
